import script from "./AssistantPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./AssistantPanel.vue?vue&type=script&setup=true&lang=ts"

import "./AssistantPanel.vue?vue&type=style&index=0&id=59990f98&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59990f98"]])

export default __exports__